<template>
  <div v-loading="loading" class="nx-page nx-report-page kanban-dumper-progress">
    <nx-report-header title="翻车进度看板">
      <el-button size="small" icon="el-icon-refresh" @click="loadData">刷新数据</el-button>
    </nx-report-header>

    <div class="kb-kpi-row cols-3">
      <div v-for="(k, i) in kpis" :key="i" class="kb-kpi-card">
        <div class="kb-kpi-label">{{ k.label }}</div>
        <div class="kb-kpi-value">{{ k.value }}</div>
        <div class="kb-kpi-sub" v-html="k.sub" />
      </div>
    </div>

    <div class="kb-chart-card">
      <div class="kb-chart-head">每小时翻卸量趋势（今日）</div>
      <div ref="lineChart" class="kb-chart-box tall" />
      <p class="kb-note">单位：车厢/小时</p>
    </div>

    <div class="kb-section">
      <div class="kb-section-head">今日计划来车 vs 实际到达</div>
      <div class="kb-stat-row">
        <div class="kb-stat-card">
          <div class="kb-stat-label">计划总车数</div>
          <div class="kb-stat-value">{{ planArrival.totalPlan }}</div>
        </div>
        <div class="kb-stat-card">
          <div class="kb-stat-label">实际到达</div>
          <div class="kb-stat-value">{{ planArrival.actualArrived }}</div>
        </div>
        <div class="kb-stat-card">
          <div class="kb-stat-label">剩余</div>
          <div class="kb-stat-value">{{ planArrival.remaining }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import NxReportHeader from '@/components/nx/report/NxReportHeader.vue'
import { fetchDumperProgress } from './api'

export default {
  name: 'KanbanDumperProgress',
  components: { NxReportHeader },
  data() {
    return {
      loading: false,
      shifts: [],
      hourlyData: [],
      planArrival: { totalPlan: 0, actualArrived: 0, remaining: 0 },
      kpis: [],
      lineChartInstance: null
    }
  },
  mounted() {
    this.loadData()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    if (this.lineChartInstance) this.lineChartInstance.dispose()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const d = await fetchDumperProgress({})
        this.shifts = d.shifts || []
        this.hourlyData = d.hourlyData || []
        this.planArrival = d.planArrival || { totalPlan: 0, actualArrived: 0, remaining: 0 }
        this.buildKpis()
        this.$nextTick(() => this.renderChart())
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    buildKpis() {
      const cur = this.shifts[0] || { plan: 1, completed: 0 }
      const rate = cur.plan ? ((cur.completed / cur.plan) * 100).toFixed(1) : '0'
      const remaining = Math.max(0, cur.plan - cur.completed)
      const last = [...this.hourlyData].filter((x) => x.value > 0).pop()
      const eff = last ? `${last.value} 车厢/小时` : '0 车厢/小时'
      let cls = 'kb-tag-yellow'
      if (Number(rate) >= 90) cls = 'kb-tag-green'
      else if (Number(rate) < 60) cls = 'kb-tag-red'
      const tag = Number(rate) >= 90 ? '超前' : Number(rate) < 60 ? '滞后' : '正常'
      this.kpis = [
        {
          label: '当前班次完成率',
          value: `${rate}%`,
          sub: `<span class="kb-tag ${cls}">${tag}</span> (${cur.completed}/${cur.plan} 车厢)`
        },
        { label: '最近一小时效率', value: eff, sub: '' },
        { label: '当前班次剩余', value: String(remaining), sub: '剩余车厢数' }
      ]
    },
    onResize() {
      this.lineChartInstance && this.lineChartInstance.resize()
    },
    renderChart() {
      if (this.lineChartInstance) this.lineChartInstance.dispose()
      this.lineChartInstance = echarts.init(this.$refs.lineChart)
      this.lineChartInstance.setOption({
        tooltip: { trigger: 'axis' },
        xAxis: { type: 'category', data: this.hourlyData.map((h) => h.hour), axisLabel: { color: '#475569' } },
        yAxis: { type: 'value', name: '车厢/小时' },
        series: [
          {
            type: 'line',
            data: this.hourlyData.map((h) => h.value),
            smooth: true,
            areaStyle: { opacity: 0.12, color: '#3b82f6' },
            lineStyle: { color: '#3b82f6', width: 3 }
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
